import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import { sectionNames } from "@dashboard/intl";
import { parseQs } from "@dashboard/url-utils";
import { useIntl } from "react-intl";
import { type RouteComponentProps, Switch } from "react-router-dom";

import {
  atticIntakePath,
  atticLedgerPath,
  type AtticLedgerUrlQueryParams,
  atticLocationAddPath,
  atticLocationListPath,
  type AtticLocationListUrlQueryParams,
  atticLocationPath,
  atticLotListPath,
  type AtticLotListUrlQueryParams,
  atticLotPath,
  atticReportPath,
  atticStockLookupPath,
  type AtticStockLookupUrlQueryParams,
} from "./urls";
import AtticIntakeView from "./views/AtticIntake";
import AtticLedgerView from "./views/AtticLedger";
import AtticLocationDetailsView from "./views/AtticLocationDetails";
import AtticLocationListView from "./views/AtticLocationList";
import AtticLotDetailsView from "./views/AtticLotDetails";
import AtticLotListView from "./views/AtticLotList";
import AtticReportView from "./views/AtticReport";
import AtticStockLookupView from "./views/AtticStockLookup";

const query = <T,>(location: RouteComponentProps["location"]) =>
  parseQs(location.search.substr(1)) as T;

const StockLookup = ({ location }: RouteComponentProps) => (
  <AtticStockLookupView params={query<AtticStockLookupUrlQueryParams>(location)} />
);
const LocationList = ({ location }: RouteComponentProps) => (
  <AtticLocationListView params={query<AtticLocationListUrlQueryParams>(location)} />
);
const LocationCreate = () => <AtticLocationDetailsView code={null} />;
const LocationDetails = ({ match }: RouteComponentProps<{ code: string }>) => (
  <AtticLocationDetailsView code={decodeURIComponent(match.params.code)} />
);
const LotList = ({ location }: RouteComponentProps) => (
  <AtticLotListView params={query<AtticLotListUrlQueryParams>(location)} />
);
const LotDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <AtticLotDetailsView id={decodeURIComponent(match.params.id)} />
);
const Ledger = ({ location }: RouteComponentProps) => (
  <AtticLedgerView params={query<AtticLedgerUrlQueryParams>(location)} />
);

// Behind VIEW_INVENTORY: route.tsx gates the whole section; the write
// mutations are refused by the API without MANAGE_INVENTORY.
const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.atticInventory)} />
      <Switch>
        <Route exact path={atticStockLookupPath} component={StockLookup} />
        <Route exact path={atticLocationListPath} component={LocationList} />
        <Route exact path={atticLocationAddPath} component={LocationCreate} />
        <Route exact path={atticLocationPath(":code")} component={LocationDetails} />
        <Route exact path={atticLotListPath} component={LotList} />
        <Route exact path={atticLotPath(":id")} component={LotDetails} />
        <Route exact path={atticIntakePath} component={AtticIntakeView} />
        <Route exact path={atticLedgerPath} component={Ledger} />
        <Route exact path={atticReportPath} component={AtticReportView} />
      </Switch>
    </>
  );
};

export default Component;
